<template>
  <div class="footerbox" ref="footers">
    <div class="footer">
      <div class="logobox">
        <img :src="siteInfo.logo" />
        <!--
                <div style="width:350px;text-indent:15px;">
                  屋聯全景是專業的全景VR製作與發佈平台，雲集全國頂尖全景攝影師，打造高質量的全景作品；同時為商家提供全景拍攝、全景內容製作等服務。
                </div>
        -->
      </div>

      <div class="infobox">
        <div class="infonav">
          <span v-for="(item,index) in navList" @click="goArticle(item.id)">{{item.title}}</span>
          <!-- <span @click="goArticle(2)">{{$t('descriptions.agent')}}</span>
          <span @click="goArticle(3)">{{$t('descriptions.support')}}</span>
          <span @click="goArticle(4)">{{$t('descriptions.joinUs')}}</span> -->
        </div>
        <!-- 友情鏈接：720yun &nbsp; 全景100 &nbsp; 屋聯全景 &nbsp; insta360 &nbsp; 圓周率 -->
        <!-- <br> -->
        <div class="tel-num">{{$t('descriptions.cTel')}}：{{siteInfo.phone}}</div>
        <div class="customer-service">
          <span>{{$t('descriptions.onlineServe')}}：{{siteInfo.qq}}</span>
          <!-- <a
            target="blank"
            :href="'http://wpa.qq.com/msgrd?V=3&uin='+siteInfo.qq+'&Site=全景100&Menu=yes'"
          >
            <img src="http://720.lolochen.com//static/images/qq_online.png" />
          </a> -->
        </div>
        <div class="datas">
          <span>Copyright&copy;{{siteInfo.sitename}} {{$t('descriptions.allRights')}}</span>
          <a target="_blank" href="https://beian.miit.gov.cn/">{{siteInfo.icp}}</a>
          <span>{{siteInfo.address}}</span>
        </div>
      </div>
      <div class="codebox">
        <div style="margin-bottom:5px;">{{$t('descriptions.scanFollow')}}</div>
        <img :src="siteInfo.enterprise_qrCode" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import {queryBottomNav} from "@/api/index";
export default {
  name: "footers",
  computed: {
    ...mapState({
      siteInfo: (state) => state.siteConfig.siteInfo,
    }),
  },
  data(){
    return{
      navList:[]
    }
  },
  mounted() {
    let h =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.$nextTick(() => {
      let footerH = this.$refs.footers.offsetHeight;
    });
    this.getNav();
  },
  methods: {
    goArticle(id) {
      const { href } = this.$router.resolve({
        path: "/new/" + id,
      });
      window.open(href, "_blank");
    },
    getNav(){
      queryBottomNav().then(res=>{
        this.navList = res.data;
      })
    }
  },
};
</script>

<style lang="less" scoped>
.footerbox {
  background: #333;
  color: rgba(255, 255, 255, 0.5);
  .footer {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 10px;
    display: flex;
    justify-content: space-between;
    .logobox {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      img {
        max-height: 40px;
      }
    }
    .infobox {
      width: 100%;
      padding: 20px 50px 0 70px;
      box-sizing: border-box;
      .infonav {
        color: rgba(255, 255, 255, 0.8);
        font-weight: bold;
        margin-bottom: 5px;
        span {
          margin-right: 20px;
          cursor: pointer;
          &:hover {
            color: rgba(255, 255, 255, 1);
          }
        }
      }
      .tel-num {
        margin-bottom: 5px;
      }
      .customer-service {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
        a {
          cursor: pointer;
        }
      }
      .datas {
        span {
          display: inline-block;
          margin-right: 10px;
        }
        a {
          color: rgba(255, 255, 255, 0.5);
          margin-right: 10px;
        }
      }
    }
    .codebox {
      flex-shrink: 0;
      text-align: center;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
}
@media (max-width: 768px) {
  .footerbox {
    .footer {
      flex-wrap: wrap;
      .logobox {
        width: 100%;
        display: flex;
        justify-content: center;
        img {
          margin-top: 0;
        }
      }
      .infobox {
        margin: 30px 0;
        padding: 30px 20px;
        border-top: 1px solid rgba(255, 255, 255, 0.05);
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      }
      .codebox {
        width: 100%;
      }
    }
  }
}
</style>
